import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../components/Table';
import { useTable } from '../hooks/useTable';
import { Breadcrumbs, EmptyState, RbContextMenu } from '@scmlatam/web-ui';
import { AddPaycodeDialog } from '../components/AddPaycodeDialog';
import { AddShiftDialog } from '../components/AddShiftDialog';
import { DeletePaycodeDialog } from '../components/DeletePaycodeDialog';
import { UpdatePaycodeDialog } from '../components/UpdatePaycodeDialog';
import { UpdateShiftDialog } from '../components/UpdateShiftDialog';
import { useFormAddPaycode } from '../hooks/useFormAddPaycode';
import { useFormAddShift } from '../hooks/useFormAddShift';
import { useFormDeletePaycode } from '../hooks/useFormDeletePaycode';
import { useFormUpdatePaycode } from '../hooks/useFormUpdatePaycode';
import { useFormUpdateShift } from '../hooks/useFormUpdateShift';
import { useDeleteShift } from '../hooks/useFormDeleteShift';
import { DeleteShiftDialog } from '../components/DeleteShiftDialog';
import { getPermisosSchedule, usePermisoSchedule } from '../../../../auth/permisosModulos';
import { useAuthorization } from '../../../../contexts/AuthorizationContext';

const SubPage = () => {
    const { authorization, isLoading } = useAuthorization();
    const canListSchedules = usePermisoSchedule('list_schedules');
    const missingPermissions = getPermisosSchedule('list_schedules').filter((permission) => !authorization?.permissions.includes(permission));

    useEffect(() => {
        if (!isLoading) {
            const permissions = authorization?.permissions ?? [];
            const scheduledPermissions = permissions.filter((permission) => permission.startsWith('scheduled.'));
            const schedulerPermissions = permissions.filter((permission) => permission.startsWith('scheduler.'));

            console.info('[Schedule] Permisos scheduled:', scheduledPermissions);
            console.info('[Schedule] Permisos scheduler:', schedulerPermissions);
        }
    }, [authorization?.permissions, isLoading]);

    if (!canListSchedules) {
        return (
            <div id="schedule-page-no-permission" style={{ display: 'contents' }}>
                <EmptyState variant="no-permission" permissions={missingPermissions} context="page" />
            </div>
        );
    }

    return <ScheduleContent />;
};

const ScheduleContent = () => {
    const { t } = useTranslation('schedule.table');

    const tableProps = useTable();

    const formAddShiftProps = useFormAddShift({
        employees: tableProps.employees,
        selectedEmployeeIds: tableProps.selectedRowIds,
        reload: tableProps.reload,
        option: tableProps.option,
        setOption: tableProps.setOption,
    });

    const formAddPaycodeProps = useFormAddPaycode({
        employees: tableProps.employees,
        selectedEmployeeIds: new Set(Array.from(tableProps.selectedRowIds, String)),
        reload: tableProps.reload,
        option: tableProps.option,
        setOption: tableProps.setOption,
    });

    const formUpdatePaycodeProps = useFormUpdatePaycode({
        employees: tableProps.employees,
        paycodeAssignId: tableProps.paycodeAssignId,
        reload: tableProps.reload,
        option: tableProps.option,
        setOption: tableProps.setOption,
    });

    const formUpdateShiftProps = useFormUpdateShift({
        employees: tableProps.employees,
        shift: tableProps.shift,
        shiftId: tableProps.shiftId,
        reload: tableProps.reload,
        option: tableProps.option,
        setOption: tableProps.setOption,
    });

    const formDeletePaycodeProps = useFormDeletePaycode({
        paycodeAssignId: tableProps.paycodeAssignId,
        reload: tableProps.reload,
        option: tableProps.option,
        setOption: tableProps.setOption,
    });

    const formDeleteShiftProps = useDeleteShift({
        shiftAssignId: tableProps.shiftId,
        reload: tableProps.reload,
        option: tableProps.option,
        setOption: tableProps.setOption,
    });

    return (
        <div
            id="schedule-page-view"
            style={{
                height: '83.25vh',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
            }}
        >
            <div id="schedule-page-breadcrumbs" style={{ display: 'contents' }}>
                <Breadcrumbs queryKeys={['module', 'view']} className="w-full" />
            </div>

            <Table t={t} {...tableProps} rowSelected={tableProps.rowSelected} setRowSelected={tableProps.setRowSelected} />

            {Boolean(tableProps.contextMenu) && tableProps.items.length > 0 && (
                <div id="schedule-page-context-menu" style={{ display: 'contents' }}>
                    <RbContextMenu
                        open={Boolean(tableProps.contextMenu) && tableProps.items.length > 0}
                        position={tableProps.contextMenu}
                        variant={'light'}
                        items={tableProps.items}
                        onClose={() => tableProps.setContextMenu(null)}
                    />
                </div>
            )}

            {formAddShiftProps.openForm && <AddShiftDialog formProps={formAddShiftProps} />}

            {formAddPaycodeProps.openForm && <AddPaycodeDialog formProps={formAddPaycodeProps} />}

            {formUpdatePaycodeProps.openForm && <UpdatePaycodeDialog formProps={formUpdatePaycodeProps} />}

            {formUpdateShiftProps.openForm && <UpdateShiftDialog formProps={formUpdateShiftProps} />}

            {formDeletePaycodeProps.openForm && <DeletePaycodeDialog formProps={formDeletePaycodeProps} />}

            {formDeleteShiftProps.openForm && <DeleteShiftDialog formProps={formDeleteShiftProps} />}
        </div>
    );
};

export { SubPage };
